<template>
  <div id="Users">
    <MyHeaderPage :title="$t('nav.gestioneCredito')" />
    <br /><br />

    <div class="mdl-grid">
      <div class="mdl-cell mdl-cell--12-col" style="text-align: right">
        <span class="remaining-credit">
          {{ $i18n.locale === "it" ? "Token residui" : "Remaining tokens" }}:
          {{ currency(credit) }}
        </span>
        <button
          class="cdlButtonGreen compact"
          @click="openNotifications"
          id="btnCreditNotifications"
        >
          {{ $t("creditNotifications.title") }}
        </button>
      </div>
    </div>

    <div id="TicketsList">
      <div class="listTicket">
        <!-- Filters -->
        <div class="mdl-grid">
          <!-- Search input like other reports -->
          <div class="mdl-cell mdl-cell--6-col mdl-cell--12-col-phone">
            <div class="filterTickets">
              <div class="contentInputFilter">
                <div class="contentIcon">
                  <span class="material-icons">search</span>
                </div>
                <div class="contentInput">
                  <input
                    type="text"
                    :placeholder="$t('actions.text_search_placeholder')"
                    v-model="searchString"
                    @keyup="searchByString"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">
            <div class="cdl-input" style="margin-top: 0">
              <input
                type="date"
                name="dateFrom"
                class="not-empty"
                v-model="from"
                style="background-color: white"
                @change="load(1)"
              />
              <label>{{ $t("reports.filter.dateFrom") }}</label>
            </div>
          </div>

          <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">
            <div class="cdl-input" style="margin-top: 0">
              <input
                type="date"
                name="dateTo"
                class="not-empty"
                v-model="to"
                style="background-color: white"
                @change="load(1)"
              />
              <label>{{ $t("reports.filter.dateTo") }}</label>
            </div>
          </div>

          <div class="mdl-cell mdl-cell--12-col" v-if="error">
            <span class="error">{{ $t(error) }}</span>
          </div>
        </div>

        <!--    &lt;!&ndash; Credit meter (compact) &ndash;&gt;-->
        <!--    <div class="mdl-grid">-->
        <!--      <div class="mdl-cell mdl-cell&#45;&#45;12-col">-->
        <!--        <div class="credit-meter">-->
        <!--          <div class="bar">-->
        <!--            <div class="fill" :style="{ width: usagePercentage + '%' }"></div>-->
        <!--            <div class="pointer" :style="{ left: usagePercentage + '%' }"></div>-->
        <!--          </div>-->
        <!--          <div class="info">-->
        <!--            <span class="credit">{{ currency(credit) }}</span>-->
        <!--            <span class="usage">{{ usagePercentage }}%</span>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--      </div>-->
        <!--    </div>-->

        <!-- List -->
        <div class="mdl-grid">
          <div class="mdl-cell mdl-cell--12-col">
            <table class="cloud-report-table">
              <thead v-if="!this.$IsMobile()">
                <tr>
                  <th class="col-date">{{ $t("reports.columns.date") }}</th>
                  <th class="col-description">
                    {{ $t("reports.columns.description") }}
                  </th>
                  <th class="col-charge right">
                    {{ $t("reports.columns.amount") }}
                  </th>
                </tr>
              </thead>

              <tbody
                v-if="
                  !this.$IsMobile() &&
                  viewLoader &&
                  visibleTransactions.length > 0
                "
              >
                <tr
                  v-for="(t, idx) in visibleTransactions"
                  :key="idx"
                  :class="{ odd: idx % 2 }"
                >
                  <td class="col-date">{{ formatDate(t.transactionDate) }}</td>
                  <td class="col-description">{{ t.description }}</td>
                  <td
                    class="col-charge right"
                    :class="{
                      neg: Number(t.signedAmount) < 0,
                      pos: Number(t.signedAmount) > 0,
                    }"
                  >
                    {{ currency(t.signedAmount) }}
                  </td>
                </tr>
              </tbody>

              <tbody
                v-else-if="
                  this.$IsMobile() && viewLoader && visibleTransactions.length > 0
                "
              >
                <tr
                  v-for="(t, idx) in visibleTransactions"
                  :key="idx"
                  :class="{ odd: idx % 2 }"
                >
                  <td>
                    <div>
                      <strong>{{ $t("reports.columns.date") }}</strong>
                    </div>
                    <div>{{ formatDate(t.transactionDate) }}</div>
                    <br />
                    <div>
                      <strong>{{ $t("reports.columns.description") }}</strong>
                    </div>
                    <div>{{ t.description }}</div>
                    <br />
                    <div>
                      <strong>{{ $t("reports.columns.amount") }}</strong>
                    </div>
                    <div
                      :class="{
                        neg: Number(t.signedAmount) < 0,
                        pos: Number(t.signedAmount) > 0,
                      }"
                    >
                      {{ currency(t.signedAmount) }}
                    </div>
                  </td>
                </tr>
              </tbody>

              <tbody v-if="viewLoader && visibleTransactions.length === 0">
                <tr>
                  <td colspan="3">
                    <span class="noTickets">{{ $t("reports.noResult") }}</span>
                  </td>
                </tr>
              </tbody>
            </table>

            <div>
              <MyLoading :viewLoader="viewLoader" type="" />
            </div>
            <Paginator
              v-if="viewLoader && total > 0"
              :total-page="totalPages"
              :current-page="currentPage"
              @prev-page="beforePage"
              @next-page="nextPage"
              @change-page="changePage"
            />
          </div>
        </div>
      </div>
    </div>

    <keep-alive>
      <CreditNotificationsPanel
        :view="showNotifPanel"
        :settings="notifSettings"
        @close-panel="closeNotifications"
        @saved="onNotificationsSaved"
      />
    </keep-alive>
  </div>
</template>

<script>
import MyHeaderPage from "@/components/MyHeaderPage.vue";
import { GestioneCreditoService } from "@/services/GestioneCreditoService";
import CreditNotificationsPanel from "@/components/Timoo/CreditNotificationsPanel.vue";
import Paginator from "@/components/Paginator.vue";
import MyLoading from "@/components/MyLoading.vue";
import "@/assets/scss/TicketsList.scss";

export default {
  name: "GestioneCredito",
  components: { MyHeaderPage, CreditNotificationsPanel, Paginator, MyLoading },
  data() {
    return {
      from: "",
      to: "",
      transactions: [],
      credit: 0,
      usagePercentage: 0,
      loading: false,
      viewLoader: false,
      error: "",
      // search/filter state
      searchString: "",
      transFiltered: [],
      // pagination state
      currentPage: 1,
      perPage: 10,
      total: 0,
      totalPages: 1,
      // Side panel state
      showNotifPanel: false,
      notifSettings: { emails: [] },
    };
  },
  methods: {
    currency(v) {
      return Number(v).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    formatDate(v) {
      const d = new Date(v);
      if (isNaN(d.getTime())) return v;
      return d.toLocaleString();
    },
    async load(page = 1) {
      this.error = "";
      this.loading = true;
      this.viewLoader = false;
      this.currentPage = page || 1;
      try {
        const res = await GestioneCreditoService.getTransactions({
          from: this.from || undefined,
          to: this.to || undefined,
          page: this.currentPage,
          perPage: this.perPage,
          search: (this.searchString || '').trim() || undefined,
        });
        this.transactions = res.transactions || [];
        this.credit = Number(res.credit) || 0;
        this.usagePercentage = Math.max(
          0,
          Math.min(100, Number(res.usagePercentage) || 0)
        );
        // pagination info
        this.currentPage = Number(res.currentPage) || this.currentPage;
        this.perPage = Number(res.perPage) || this.perPage;
        this.total = Number(res.total) || 0;
        this.totalPages = Number(res.totalPages) || 1;
      } catch (e) {
        this.error = "Failedtoloaddata";
      } finally {
        this.loading = false;
        this.viewLoader = true;
      }
    },
    async openNotifications() {
      try {
        const cfg = await GestioneCreditoService.getCreditNotifications();
        this.notifSettings =
          cfg && cfg.emails ? { emails: [...cfg.emails] } : { emails: [] };
      } catch (e) {
        this.notifSettings = { emails: [] };
      }
      this.showNotifPanel = true;
    },
    closeNotifications() {
      this.showNotifPanel = false;
    },
    onNotificationsSaved(payload) {
      if (payload && Array.isArray(payload.emails)) {
        this.notifSettings = { emails: [...payload.emails] };
      }
    },
    searchByString() {
      // Server-side filtering like Cloud report: search applies to amount (importo) and description
      this.currentPage = 1;
      this.load(1);
    },
    changePage(page) {
      if (this.viewLoader && page && page !== this.currentPage) {
        this.load(page);
      }
    },
    beforePage() {
      if (this.currentPage > 1 && this.viewLoader) {
        this.load(this.currentPage - 1);
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages && this.viewLoader) {
        this.load(this.currentPage + 1);
      }
    },
  },
  computed: {
    visibleTransactions() {
      // Rely on server-side filtering (dates + search) like Cloud report
      return this.transactions;
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<style scoped>
.error {
  color: #c0392b;
}
.loading {
  color: #666;
}
.pos {
  color: #2ecc71;
}
.neg {
  color: #c0392b;
}

.credit-meter {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.bar {
  position: relative;
  height: 10px;
  background: #eef2f6;
  border-radius: 999px;
  overflow: hidden;
}
.fill {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  background: linear-gradient(90deg, #4cc3ff, #0e73ff);
}
.pointer {
  position: absolute;
  top: -6px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #0e1730;
  transform: translateX(-50%);
}
.info {
  display: flex;
  gap: 16px;
  color: #0b1736;
}

/* Make the green CTA behave as a normal-sized button on the right */
.cdlButtonGreen.compact {
  width: auto;
  display: inline-block;
  padding: 12px 20px;
}
/* Remaining credit label spacing */
.remaining-credit {
  display: inline-block;
  margin-right: 16px;
  font-family: OpenSansSemiBold, sans-serif;
  font-size: 1.375rem; /* 22px */
}
</style>
